import { render } from "./ServiceDetail.vue?vue&type=template&id=39a294f7&scoped=true"
import script from "./ServiceDetail.vue?vue&type=script&lang=js"
export * from "./ServiceDetail.vue?vue&type=script&lang=js"

import "./ServiceDetail.vue?vue&type=style&index=0&id=39a294f7&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a294f7"]])

export default __exports__